'use strict'
module.exports = function (Yallist) {
  Yallist.prototype[Symbol.iterator] = function* () {
    for (let walker = this.head; walker; walker = walker.next) {
      yield walker.value
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/yallist/iterator.js
// module id = 2024
// module chunks = 0 1 3